import { NumberInput, Checkbox } from "@heroui/react";
import { Controller } from "react-hook-form";
import AddressBlock from "./AddressBlock";

const AddressStep = ({ register, errors, control, watch, setValue }) => {
    return (
        <div className="flex flex-col gap-6">
            {/* Identity Number */}
            <Controller
                name="identity_number"
                control={control}
                rules={{
                    required: "Nomor KTP (NIK) wajib diisi",
                    validate: (value) =>
                        String(value).length === 16 ||
                        "Nomor KTP (NIK) harus 16 digit",
                }}
                render={({ field }) => (
                    <NumberInput
                        label="Nomor KTP (NIK)"
                        placeholder="Masukkan nomor KTP (NIK)"
                        value={field.value}
                        onValueChange={field.onChange}
                        errorMessage={errors.identity_number?.message}
                        isInvalid={!!errors.identity_number}
                        variant="bordered"

                        formatOptions={{ useGrouping: false }}
                        isRequired
                        hideStepper
                        maxLength={16}
                    />
                )}
            />

            {/* Alamat KTP */}
            <AddressBlock
                prefix="ktp_address"
                label="Alamat Sesuai KTP"
                watch={watch}
                setValue={setValue}
                register={register}
            />

            {/* Domicile Checkbox */}
            <Controller
                name="is_domicile_same_as_ktp"
                control={control}
                render={({ field }) => (
                    <Checkbox
                        isSelected={field.value}
                        onValueChange={field.onChange}
                        classNames={{ label: "text-sm" }}
                    >
                        Checklist jika alamat yang di tinggali saat ini sama
                        dengan alamat KTP
                    </Checkbox>
                )}
            />

            {/* Domicile Address (if different) */}
            {!watch("is_domicile_same_as_ktp") && (
                <AddressBlock
                    prefix="domicile_address"
                    label="Alamat Tinggal Saat Ini"
                    watch={watch}
                    setValue={setValue}
                    register={register}
                />
            )}
        </div>
    );
};

export default AddressStep;
